import {Button} from '@components/common/button/button'
import {LabeledInput} from '@components/common/labeled-input/labeled-input'
import {Popup} from '@components/common/popup/popup'
import {createUseStore, useGlobalKeyDown} from '@containers/hooks'
import {withDefaultProps} from '@containers/with-props'
import {observer} from 'mobx-react-lite'
import React, {useRef, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {RegistrationFinishStore} from './registration-finish-store'

const [Context, useStore] = createUseStore(RegistrationFinishStore)

export const RegistrationFinishPopup = observer(() => {
  const [store] = useState(() => new RegistrationFinishStore())
  enableTestShortcut(store)
  return (
    <Context.Provider value={store}>
      {store.state.show ? <RegPopup /> : null}
    </Context.Provider>
  )
})

const RegPopup = observer(() => {
  return (
    <Popup
      close={'disabled'}
      title={Lang.msg.reg.finishTitle}
      width={380}
      autoHeight
      footer={<Footer />}
    >
      <Form />
    </Popup>
  )
})

const LargeLabeledInput = withDefaultProps(LabeledInput, {large: true})
const TwInput = tw(LargeLabeledInput)`my-16`

const Form = observer(() => {
  const [state, store] = useStore()
  const nameRef = useRef<HTMLElement>()
  const phoneRef = useRef<HTMLElement>()
  return (
    <form>
      <TwInput
        autoFocus
        value={state.companyName}
        label={Lang.msg.reg.companyLabel + ':'}
        placeholder={Lang.msg.reg.companyPlaceholder}
        onChange={value => store.changeCompany(value)}
        isCorrect={store.isCorrectCompany}
        hasError={state.errors.companyName}
        onEnter={() => nameRef.current?.focus()}
      />
      <TwInput
        value={state.userName}
        label={Lang.msg.reg.usernameLabel + ':'}
        placeholder={Lang.msg.reg.usernamePlaceholder}
        onChange={value => store.changeName(value)}
        innerRef={nameRef}
        isCorrect={store.isCorrectName}
        hasError={state.errors.userName}
        onEnter={() => phoneRef.current?.focus()}
      />
      <TwInput
        value={state.phone}
        label={Lang.msg.reg.phoneLabel + ':'}
        placeholder={Lang.msg.reg.phonePlaceholder}
        onChange={value => store.changePhone(value)}
        innerRef={phoneRef}
        isCorrect={store.isCorrectPhone}
        hasError={state.errors.phone}
        onEnter={() => store.submit()}
      />
    </form>
  )
})

const Footer = observer(() => {
  const [, store] = useStore()
  return (
    <Button className="px-32" onClick={() => store.submit()}>
      {Lang.msg.done}
    </Button>
  )
})

const enableTestShortcut = (store: RegistrationFinishStore) =>
  useGlobalKeyDown({
    anyKey: async ({keyCode, alt, ctrl, shift}) => {
      if (alt && ctrl && shift && keyCode === 71 /* G */) {
        void store.sendTestRequest()
      }
    }
  })
